const MacroCalculator = (app) => {
  app.post("/macro-calculator/save/:id?", async ({ api, flash, req, res }) => {
    const { body, params } = req;

    if (params.id) {
      await api(`macro-calculator/${params.id}`, {
        method: "PUT",
        body,
      }).then((res) => {
        if (res.status !== 200) {
          const error = new Error(res.statusText);
          error.code = res.status;
          throw error;
        }
      });
    } else {
      await api("macro-calculator", {
        method: "POST",
        body,
      }).then((res) => {
        if (res.status !== 200 && res.status !== 201) {
          const error = new Error(res.statusText);
          error.code = res.status;
          throw error;
        }
      });
    }

    flash("success", "Successfully saved");

    res.backDontScroll();
  });
};

export default MacroCalculator;
